export default "__VITE_ASSET__CpDwF7ik__"